import { useMemo } from 'react';
import { MenuNavigationShellPage } from '@/app/layout/MenuNavigationShellPage';
import type { AgendaRegistration } from '@/app/layout/MenuNavigationShellPage';
import { PRODUCTS_STATIONS } from './permissions';
import {
  stationDetailAgenda,
  StationDetailPage,
  stationListAgenda,
  StationListPage,
} from './stations';

export function ProductsSlicePage() {
  const agendas: AgendaRegistration[] = useMemo(
    () => [
      { agenda: stationListAgenda, component: StationListPage, permission: PRODUCTS_STATIONS },
      { agenda: stationDetailAgenda, component: StationDetailPage, permission: PRODUCTS_STATIONS },
    ],
    []
  );

  return <MenuNavigationShellPage agendas={agendas} rootAgenda={stationListAgenda} />;
}
